/*
  Illumaesthetic site system (ix-*): catalog tabs, project filters, the
  project photo viewer, clearing the see-through homepage header above
  the hero, and the hover videos on feature tiles.
  Both work without this script: every tab panel and every project is in the
  page, and only the first panel is hidden by the server when JS is present.
  Re-initialises when a section is edited in the theme editor.
*/
(function () {
  'use strict';

  function initTabs(root) {
    var tablists = (root || document).querySelectorAll('[data-ix-tabs]:not([data-ix-ready])');
    Array.prototype.forEach.call(tablists, function (list) {
      list.setAttribute('data-ix-ready', '');
      var tabs = Array.prototype.slice.call(list.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
          if (on && panel) {
            Array.prototype.forEach.call(panel.querySelectorAll('.ia-reveal'), function (el) { el.classList.add('is-visible'); });
          }
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          else if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          else if (e.key === 'Home') next = tabs[0];
          else if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
      var current = tabs.filter(function (t) { return t.getAttribute('aria-selected') === 'true'; })[0] || tabs[0];
      if (current) select(current, false);
    });
  }

  function initFilters(root) {
    var groups = (root || document).querySelectorAll('[data-ix-filters]:not([data-ix-ready])');
    Array.prototype.forEach.call(groups, function (group) {
      group.setAttribute('data-ix-ready', '');
      group.hidden = false;
      var target = document.getElementById(group.getAttribute('data-ix-filters'));
      if (!target) return;
      var buttons = Array.prototype.slice.call(group.querySelectorAll('[data-ix-filter]'));
      var items = Array.prototype.slice.call(target.querySelectorAll('[data-ix-sector]'));
      var status = group.querySelector('[data-ix-filter-status]');
      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          var value = btn.getAttribute('data-ix-filter');
          buttons.forEach(function (b) { b.setAttribute('aria-pressed', b === btn ? 'true' : 'false'); });
          var shown = 0;
          items.forEach(function (item) {
            var match = value === 'all' || (' ' + item.getAttribute('data-ix-sector') + ' ').indexOf(' ' + value + ' ') !== -1;
            item.hidden = !match;
            if (match) {
              shown += 1;
              item.classList.add('is-visible');
            }
          });
          if (status) status.textContent = shown + ' ' + (shown === 1 ? 'project' : 'projects');
        });
      });
    });
  }

  // Project photo viewer. Every link with the same data-ix-gallery value is
  // one set; clicking one opens a modal dialog at that photo. Without
  // <dialog> support the links just open the full-size photo.
  var viewer = null;
  function buildViewer() {
    var d = document.createElement('dialog');
    d.className = 'ix-lightbox';
    d.setAttribute('aria-label', 'Project photos');
    d.innerHTML =
      '<figure class="ix-lightbox__figure"><img alt=""><figcaption class="ix-lightbox__caption" aria-live="polite"></figcaption></figure>' +
      '<button type="button" class="ix-lightbox__btn ix-lightbox__prev" aria-label="Previous photo">&#8592;</button>' +
      '<button type="button" class="ix-lightbox__btn ix-lightbox__next" aria-label="Next photo">&#8594;</button>' +
      '<button type="button" class="ix-lightbox__btn ix-lightbox__close" aria-label="Close">&#215;</button>';
    document.body.appendChild(d);
    var v = { el: d, img: d.querySelector('img'), cap: d.querySelector('figcaption'), items: [], i: 0 };
    v.show = function (i) {
      v.i = (i + v.items.length) % v.items.length;
      var a = v.items[v.i];
      v.img.src = a.getAttribute('href');
      v.img.alt = a.getAttribute('data-ix-alt') || '';
      v.cap.textContent = v.img.alt ? v.img.alt + '  /  ' : '';
      var n = document.createElement('span');
      n.textContent = (v.i + 1) + ' of ' + v.items.length;
      v.cap.appendChild(n);
    };
    d.querySelector('.ix-lightbox__prev').addEventListener('click', function () { v.show(v.i - 1); });
    d.querySelector('.ix-lightbox__next').addEventListener('click', function () { v.show(v.i + 1); });
    d.querySelector('.ix-lightbox__close').addEventListener('click', function () { d.close(); });
    d.addEventListener('click', function (e) { if (e.target === d || e.target.classList.contains('ix-lightbox__figure')) d.close(); });
    d.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') v.show(v.i - 1);
      else if (e.key === 'ArrowRight') v.show(v.i + 1);
    });
    d.addEventListener('close', function () { v.img.removeAttribute('src'); });
    return v;
  }

  function initGallery() {
    if (document.documentElement.hasAttribute('data-ix-gallery')) return;
    document.documentElement.setAttribute('data-ix-gallery', '');
    document.addEventListener('click', function (e) {
      var a = e.target.closest ? e.target.closest('a[data-ix-gallery]') : null;
      if (!a || e.metaKey || e.ctrlKey || e.shiftKey || e.button !== 0) return;
      if (typeof HTMLDialogElement !== 'function') return;
      e.preventDefault();
      viewer = viewer || buildViewer();
      var set = a.getAttribute('data-ix-gallery');
      viewer.items = Array.prototype.filter.call(document.querySelectorAll('a[data-ix-gallery]'), function (x) {
        return x.getAttribute('data-ix-gallery') === set;
      });
      var single = viewer.items.length < 2;
      viewer.el.querySelector('.ix-lightbox__prev').hidden = single;
      viewer.el.querySelector('.ix-lightbox__next').hidden = single;
      viewer.show(viewer.items.indexOf(a));
      viewer.el.showModal();
    });
  }

  // On the homepage Impulse lays the header over the first section, and its
  // height changes with the menu (one or two rows). Pad the hero by the
  // header's real height so the headline never sits under it.
  function clearHeader() {
    var header = document.querySelector('.header-wrapper--sticky');
    var hero = document.querySelector('main .ix-hero, main .ix-tile--hero, main .ix-collage');
    if (!header || !hero) return;
    hero.style.setProperty('--ix-header-clear', header.offsetHeight + 'px');
  }

  // Page hero with the text below the photo's subject (data-ix-subject =
  // "top,bottom" as % of the photo's height). The photo is cropped so the
  // subject sits below the header and above the text at any window shape;
  // when the window is too short for both, the hero grows instead.
  // Each photo in the page hero is cropped so its subject band (top and
  // bottom, % of photo height) sits between the header and the text. A
  // rotating hero has several photos, each with its own band (data-ix-subject
  // on the img, else the tile's); the tile grows once to fit the tallest
  // need, so it keeps one height as the photos change.
  function placeHero() {
    var tile = document.querySelector('.ix-tile--hero[data-ix-subject]');
    if (!tile) return;
    var copy = tile.querySelector('.ix-tile__copy');
    var imgs = Array.prototype.slice.call(tile.querySelectorAll('.ix-tile__media img'));
    if (!imgs.length || !copy) return;
    // Measure with transitions off: the theme's reduced-motion rule gives
    // everything a 0.01ms transition, which would make min-height changes
    // read back stale and the hero alternate between two heights.
    tile.style.transition = 'none';
    tile.style.minHeight = '';
    imgs.forEach(function (img) { img.style.objectPosition = ''; });
    // Phones and portrait tablets stack the photo above the text (ix-site.css).
    if (window.matchMedia('(max-width: 749px), (min-width: 750px) and (max-width: 1100px) and (orientation: portrait)').matches) return;
    // Each photo's shape comes from its width/height attributes when it hasn't
    // loaded yet, so the hero's height doesn't depend on which slides have
    // finished loading when this runs.
    var ready = imgs.filter(function (img) {
      img._ixW = img.naturalWidth || parseFloat(img.getAttribute('width'));
      img._ixH = img.naturalHeight || parseFloat(img.getAttribute('height'));
      if (img._ixW && img._ixH) return true;
      img.addEventListener('load', placeHero, { once: true });
      return false;
    });
    if (!ready.length) return;
    var header = document.querySelector('.header-wrapper--sticky');
    var clear = (header ? header.offsetHeight : 0) + 24;
    var gap = 16;
    function fit(img, h) {
      var band = (img.getAttribute('data-ix-subject') || tile.getAttribute('data-ix-subject')).split(',');
      var top = parseFloat(band[0]) / 100, bottom = parseFloat(band[1]) / 100;
      var w = tile.clientWidth;
      var scale = Math.max(w / img._ixW, h / img._ixH);
      var H = img._ixH * scale;
      var copyTop = copy.offsetTop + (h - tile.clientHeight);
      return { over: Math.max(0, H - h), maxCrop: top * H - clear, minCrop: bottom * H - (copyTop - gap) };
    }
    // Grow the tile once, by the largest shortfall of any photo.
    var h = tile.clientHeight, need = 0;
    ready.forEach(function (img) { var f = fit(img, h); need = Math.max(need, f.minCrop - f.maxCrop); });
    // ...but never taller than the window, so the buttons stay in view.
    need = Math.min(need, Math.max(0, window.innerHeight - h));
    if (need > 0) tile.style.minHeight = Math.ceil(h + need) + 'px';
    h = tile.clientHeight;
    ready.forEach(function (img) {
      var f = fit(img, h);
      var crop = Math.min(f.over, Math.max(0, Math.max(f.minCrop, Math.min(f.maxCrop, f.over))));
      // Across, centre on the slide's own focus (Hero photo blocks), else the middle.
      var x = img.style.getPropertyValue('--ix-slide-x') || '50%';
      img.style.objectPosition = x + ' ' + (f.over > 0 ? (crop / f.over) * 100 : 50) + '%';
    });
  }

  // Feature tiles with text on top: keep the photo's subject a fixed gap
  // below the text at every width. Each tile carries its subject band
  // (data-ix-place: top, bottom, left, right, as % of the photo). The photo
  // is drawn at the smallest size that fills the tile and puts the subject's
  // top at the gap, but never so large that the subject's sides are cut off;
  // if that leaves room above the photo, its top edge fades into the tile.
  // The tile's height is set to end a little below the subject; tiles in a
  // row share the tallest height, and the others zoom to fill it, up to the
  // same limit, then fade their bottom edge instead.
  var TILE_GAP = 28, TILE_FLOOR = 0.1, TILE_FADE = 160;
  function placeTiles() {
    var tiles = Array.prototype.slice.call(document.querySelectorAll('.ix-tile[data-ix-place]'));
    var jobs = [];
    tiles.forEach(function (tile) {
      var img = tile.querySelector('.ix-tile__media img');
      var copy = tile.querySelector('.ix-tile__copy');
      tile.style.minHeight = '';
      if (!img || !copy) return;
      // The photo's shape comes from its width/height attributes, so tiles
      // further down are placed before their (lazy) photos arrive.
      var nw = img.naturalWidth || parseFloat(img.getAttribute('width'));
      var nh = img.naturalHeight || parseFloat(img.getAttribute('height'));
      if (!nw || !nh) { img.addEventListener('load', placeTiles, { once: true }); return; }
      var b = tile.getAttribute('data-ix-place').split(',').map(function (v) { return parseFloat(v) / 100; });
      jobs.push({ tile: tile, img: img, copy: copy, t: b[0], b: b[1], l: b[2], r: b[3], a: nw / nh });
    });
    function size(j, h) {
      var W = j.tile.clientWidth;
      var top = j.copy.offsetTop + j.copy.offsetHeight + TILE_GAP;   // where the subject starts
      var fit = W / j.a;                                              // photo height at tile width
      var maxH = W / (j.a * Math.max(0.05, j.r - j.l)) * 0.94;        // subject sides stay in view
      var H = Math.max(fit, Math.min(j.t > 0 ? top / j.t : fit, maxH));
      if (h) H = Math.max(H, Math.min(maxH, (h - top) / Math.max(0.05, 1 - j.t)));   // fill a taller row
      return { W: W, H: H, top: top };
    }
    // Pass 1: each tile's own height; the grid row takes the tallest.
    jobs.forEach(function (j) {
      var z = size(j);
      var y = z.top - j.t * z.H;
      j.want = Math.ceil(y + z.H * Math.min(1, j.b + TILE_FLOOR));
    });
    jobs.forEach(function (j) { j.tile.style.minHeight = j.want + 'px'; });
    // Pass 2: size and place each photo for the height it actually got.
    jobs.forEach(function (j) {
      var h = j.tile.clientHeight;
      var z = size(j, h);
      var Wi = z.H * j.a;
      var y = z.top - j.t * z.H;
      var x = Math.min(0, Math.max(z.W - Wi, z.W / 2 - ((j.l + j.r) / 2) * Wi));
      var st = j.img.style;
      st.position = 'absolute';
      st.left = x + 'px';
      st.top = y + 'px';
      st.width = Wi + 'px';
      st.height = z.H + 'px';
      st.maxWidth = 'none';
      // Ask for a file as wide as the photo is drawn, not the tile's 50vw.
      j.img.sizes = Math.ceil(Wi) + 'px';
      // Fade an edge that falls short of the tile into the tile's background.
      var a = y > 0 ? Math.min(TILE_FADE, j.t * z.H * 0.8) : 0;
      var bottom = y + z.H < h - 1 ? Math.min(TILE_FADE, (1 - j.b) * z.H * 0.8) : 0;
      var fade = a || bottom ? 'linear-gradient(180deg, transparent 0, #000 ' + a + 'px, #000 ' + (z.H - bottom) + 'px, transparent ' + z.H + 'px)' : '';
      st.webkitMaskImage = fade;
      st.maskImage = fade;
      j.tile.classList.add('is-placed');
      // Touch screens play the tile's video under the text (see initTileVideos).
      // It starts right under the text, so its fade-in is over before the photo's subject begins.
      j.tile.style.setProperty('--ix-video-top', Math.round(z.top - TILE_GAP) + 'px');
    });
  }

  // Rotating page hero: crossfade to the next photo every few seconds, with
  // its caption. Waits for a photo that hasn't loaded, stops while the tab is
  // hidden or the pause button is pressed, and never runs with reduced motion.
  function initHeroRotate() {
    var tile = document.querySelector('.ix-tile--rotating[data-ix-rotate]');
    if (!tile || tile.dataset.rotateReady) return;
    tile.dataset.rotateReady = '1';
    var slides = tile.querySelectorAll('.ix-tile__media img.ix-tile__slide');
    var captions = tile.querySelectorAll('[data-ix-slide-caption]');
    if (slides.length < 2 || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    var hold = (parseFloat(tile.getAttribute('data-ix-rotate')) || 6) * 1000;
    tile.style.setProperty('--ix-rotate', hold / 1000 + 's');
    var fade = 1600, i = 0, timer = null, paused = false;
    // Start loading the other photos once the first one is in.
    function warm() { slides.forEach(function (img) { img.loading = 'eager'; }); }
    if (slides[0].complete) warm(); else slides[0].addEventListener('load', warm, { once: true });
    function show(n) {
      var prev = slides[i];
      prev.classList.remove('is-active');
      prev.classList.add('is-leaving');
      slides[n].classList.add('is-active');
      captions.forEach(function (c, k) { c.hidden = k !== n; });
      setTimeout(function () { prev.classList.remove('is-leaving'); }, fade + 50);
      i = n;
    }
    function tick() {
      timer = null;
      if (paused || document.hidden) return;
      var n = (i + 1) % slides.length;
      if (slides[n].complete && slides[n].naturalWidth) show(n);
      schedule(slides[n].naturalWidth ? hold + fade : 1000);
    }
    function schedule(ms) { if (!timer) timer = setTimeout(tick, ms); }
    schedule(hold);
    document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(hold); });
    var btn = tile.querySelector('[data-ix-rotate-toggle]');
    if (btn) btn.addEventListener('click', function () {
      paused = !paused;
      tile.classList.toggle('is-paused', paused);
      btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
      if (!paused) schedule(hold);
    });
  }

  // Project results: closed behind "More" on phones, open with no toggle
  // on wider screens. Only acts when the screen class changes, so a card
  // someone opened stays open while they scroll.
  var phoneQuery = window.matchMedia('(max-width: 749px)');
  function initCollapse(root) {
    (root || document).querySelectorAll('[data-ix-collapse]').forEach(function (d) {
      d.open = !phoneQuery.matches;
    });
  }
  if (phoneQuery.addEventListener) phoneQuery.addEventListener('change', function () { initCollapse(); });

  // Feature tiles with a hover video: the photo shows until the pointer is
  // over the tile (or a link in it has focus), then the muted loop fades in
  // once it is actually playing. The file is fetched on the first hover
  // only. On touch screens there is no hover, so the video plays while its
  // tile is mostly on screen instead: one at a time, in the photo area under
  // the text, fetched only as its tile comes into view. Reduced motion and
  // data saver keep the photo.
  var fineHover = window.matchMedia('(hover: hover) and (pointer: fine)');
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var saveData = !!(navigator.connection && navigator.connection.saveData);
  var touchVideos = [];
  var touchObserver = null;
  function playTile(entry) {
    var video = entry.video;
    entry.wanted = true;
    if (!video.getAttribute('src')) video.src = video.getAttribute('data-ix-src');
    var played = video.play();
    if (played && played.catch) played.catch(function () {});
  }
  function stopTile(entry) {
    entry.wanted = false;
    entry.tile.classList.remove('is-playing');
    entry.video.pause();
  }
  // Touch: a tile is in play when at least 60% of it is on screen (or it
  // fills half the screen, for tall tiles). Of those, the one nearest the
  // middle of the screen plays, together with its neighbour in the same row
  // on tablets; the rest pause. A video starts only after its tile has
  // stayed in play for a moment, so a quick flick down the page doesn't
  // download every clip.
  var TOUCH_DWELL = 350, touchTimer = null, touchPending = null;
  function pickTouchVideo() {
    var mid = window.innerHeight / 2, best = null, bestDist = Infinity;
    var live = touchVideos.filter(function (e) { return e.ratio >= 0.6 || e.seen >= window.innerHeight * 0.5; });
    live.forEach(function (e) {
      var r = e.tile.getBoundingClientRect();
      var d = Math.abs(r.top + r.height / 2 - mid);
      if (d < bestDist) { bestDist = d; best = e; }
    });
    var play = best && !document.hidden ? live.filter(function (e) {
      return Math.abs(e.tile.getBoundingClientRect().top - best.tile.getBoundingClientRect().top) < 8;
    }) : [];
    touchVideos.forEach(function (e) { if (e.wanted && play.indexOf(e) === -1) stopTile(e); });
    // Keep a pending start running while the same tiles stay chosen.
    var key = play.map(function (e) { return touchVideos.indexOf(e); }).join(',');
    if (key === touchPending) return;
    clearTimeout(touchTimer);
    touchPending = key;
    if (play.length) touchTimer = setTimeout(function () {
      touchPending = null;
      play.forEach(function (e) { if (!e.wanted && e.ratio > 0) playTile(e); });
    }, TOUCH_DWELL);
  }
  function initTileVideos(root) {
    (root || document).querySelectorAll('[data-ix-video]:not([data-ix-ready])').forEach(function (tile) {
      var video = tile.querySelector('.ix-tile__video');
      if (!video) return;
      tile.setAttribute('data-ix-ready', '');
      var entry = { tile: tile, video: video, wanted: false, ratio: 0, seen: 0 };
      video.muted = true;
      video.addEventListener('playing', function () { if (entry.wanted) tile.classList.add('is-playing'); });
      if (!fineHover.matches) {
        if (reduceMotion.matches || saveData || !('IntersectionObserver' in window)) return;
        tile.classList.add('is-inline-video');
        if (!touchObserver) {
          touchObserver = new IntersectionObserver(function (items) {
            items.forEach(function (it) {
              touchVideos.forEach(function (e) {
                if (e.tile !== it.target) return;
                e.ratio = it.isIntersecting ? it.intersectionRatio : 0;
                e.seen = it.isIntersecting ? it.intersectionRect.height : 0;
              });
            });
            pickTouchVideo();
          }, { threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1] });
          window.addEventListener('scroll', function () { if (touchVideos.some(function (e) { return e.ratio > 0; })) pickTouchVideo(); }, { passive: true });
          document.addEventListener('visibilitychange', pickTouchVideo);
        }
        touchVideos.push(entry);
        touchObserver.observe(tile);
        return;
      }
      function start() {
        if (reduceMotion.matches) return;
        playTile(entry);
      }
      function stop() { stopTile(entry); }
      tile.addEventListener('mouseenter', start);
      tile.addEventListener('mouseleave', stop);
      tile.addEventListener('focusin', start);
      tile.addEventListener('focusout', function (e) { if (!tile.contains(e.relatedTarget)) stop(); });
    });
  }

  // Shuffle tabs: show a random set of the pool each time the panel's
  // Shuffle button is pressed (never the same set twice running), and on
  // load for tabs set to shuffle on each visit.
  function shuffleList(list) {
    var show = parseInt(list.getAttribute('data-ix-shuffle'), 10) || 4;
    var items = Array.prototype.slice.call(list.children);
    var before = items.filter(function (li) { return !li.hidden; });
    for (var tries = 0; tries < 4; tries++) {
      for (var i = items.length - 1; i > 0; i--) {
        var j = Math.floor(Math.random() * (i + 1));
        var t = items[i]; items[i] = items[j]; items[j] = t;
      }
      var same = items.slice(0, show).every(function (li) { return before.indexOf(li) !== -1; });
      if (!same || items.length <= show) break;
    }
    items.forEach(function (li, n) {
      li.hidden = n >= show;
      li.style.setProperty('--ia-i', n % 6);
      list.appendChild(li);
    });
  }
  function initShuffle(root) {
    (root || document).querySelectorAll('[data-ix-shuffle][data-ix-shuffle-load]').forEach(shuffleList);
    (root || document).querySelectorAll('[data-ix-shuffle-btn]').forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var list = document.getElementById(btn.getAttribute('aria-controls'));
        if (list) shuffleList(list);
      });
    });
  }

  // Collage hero: loop duration from the speed setting (pixels per second)
  // and the width of one photo row; the pause button stops the drift.
  function initCollage(root) {
    (root || document).querySelectorAll('[data-ix-collage]').forEach(function (el) {
      var set = el.querySelector('.ix-collage__set');
      var speed = parseFloat(el.getAttribute('data-speed')) || 36;
      // Each set must be at least as wide as the screen, or a blank strip
      // opens before the loop resets. With few photos or short ones, repeat
      // the photos in both sets (hidden from screen readers) until it is.
      el.querySelectorAll('.ix-collage__set').forEach(function (s) {
        var items = s.querySelectorAll('.ix-collage__item:not([data-ix-clone])');
        for (var n = 0; items.length && s.offsetWidth < el.offsetWidth && n < 8; n++) {
          items.forEach(function (item) {
            var copy = item.cloneNode(true);
            copy.setAttribute('data-ix-clone', '');
            copy.setAttribute('aria-hidden', 'true');
            copy.removeAttribute('data-shopify-editor-block');
            copy.querySelectorAll('img').forEach(function (img) { img.alt = ''; img.removeAttribute('fetchpriority'); });
            s.appendChild(copy);
          });
        }
      });
      if (set) el.style.setProperty('--ix-collage-dur', Math.max(20, set.offsetWidth / speed) + 's');
      var btn = el.querySelector('[data-ix-collage-toggle]');
      if (btn && !btn.dataset.ready) {
        btn.dataset.ready = '1';
        btn.addEventListener('click', function () {
          var paused = el.classList.toggle('is-paused');
          btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        });
      }
    });
  }

  function init(root) {
    initTileVideos(root);
    initShuffle(root);
    initCollage(root);
    initTabs(root);
    initFilters(root);
    initGallery();
    initCollapse(root);
    clearHeader();
    placeHero();
    placeTiles();
    initHeroRotate();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(); });
  else init();
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  window.addEventListener('load', function () { clearHeader(); placeHero(); placeTiles(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { placeHero(); placeTiles(); });
  // Re-lay out once per frame after the window settles, not on every resize event.
  var resizeFrame = 0;
  window.addEventListener('resize', function () {
    cancelAnimationFrame(resizeFrame);
    resizeFrame = requestAnimationFrame(function () { clearHeader(); placeHero(); placeTiles(); initCollage(); });
  });
})();
